<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>活动阶段分析</span>
        </div>
        <el-form ref="queryForm" :model="queryParams" :inline="true">
          <el-form-item label="支付事件">
            <el-switch v-model="payEvent" active-color="#13ce66" inactive-color="#909399" />
          </el-form-item>
          <el-form-item label="用户类型">
            <el-select v-model="allUserEvent" placeholder="请选择">
              <el-option
                v-for="item in userType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="付费类型">
            <el-select v-model="isPay" placeholder="请选择">
              <el-option
                v-for="item in payType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="活动ID" label-width="100px">
            <el-autocomplete v-model="queryParams.id" popper-class="my-autocomplete" placeholder="请输入活动ID" :fetch-suggestions="querySearchAsync" clearable size="small" @select="handleSelect" @change="handleChange"><template slot-scope="{ item }">
              <div class="name">{{ item.id }}</div>
              <span class="addr">{{ item.name }}</span>
            </template>
            </el-autocomplete>
          </el-form-item>
          <el-form-item label="日期" prop="startDate" label-width="100px">
            <el-date-picker v-model="dateList" :disabled="dateDisabled" size="small" type="datetimerange" align="right" start-placeholder="开始日期" end-placeholder="结束日期" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" icon="el-icon-search" size="small" @click="handleQuery(false)">查询</el-button>
            <el-button type="primary" :loading="loading" icon="el-icon-search" size="small" @click="handleQuery(true)">导出</el-button>
          </el-form-item>
        </el-form>
        <el-table v-loading="tableLoad" :data="tableData" border style="width: 100%">
          <el-table-column label="阶段" align="center">
            <template slot-scope="{row,$index}">{{ row.stage }}</template>
          </el-table-column>
          <el-table-column width="100" label="停留总人数" align="center">
            <template slot-scope="{row,$index}">{{ row.total }}</template>
          </el-table-column>
          <el-table-column width="100" label="体力消耗" align="center">
            <template slot-scope="{row,$index}">{{ row.totalBet }}</template>
          </el-table-column>
          <el-table-column label="0%-10%" align="center">
            <el-table-column label="玩家数" align="center">
              <template slot-scope="{row,$index}">{{ row.p1 }}</template>
            </el-table-column>
            <el-table-column label="占比" align="center">
              <template slot-scope="{row,$index}">{{ row.total == 0 ? 0 : (row.p1/row.total*100).toFixed(2) }}</template>
            </el-table-column>
            <el-table-column v-if="queryParams.type != 'payreceive'" label="人均体力" align="center">
              <template slot-scope="{row,$index}">{{ row.p1 == 0 ? 0 : (row.bet.p1/row.p1).toFixed(2) }}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="10%-20%" align="center">
            <el-table-column label="玩家数" align="center">
              <template slot-scope="{row,$index}">{{ row.p2 }}</template>
            </el-table-column>
            <el-table-column label="占比" align="center">
              <template slot-scope="{row,$index}">{{ row.total == 0 ? 0 : (row.p2/row.total*100).toFixed(2) }}</template>
            </el-table-column>
            <el-table-column v-if="queryParams.type != 'payreceive'" label="人均体力" align="center">
              <template slot-scope="{row,$index}">{{ row.p2 == 0 ? 0 : (row.bet.p2/row.p2).toFixed(2) }}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="20%-30%" align="center">
            <el-table-column label="玩家数" align="center">
              <template slot-scope="{row,$index}">{{ row.p3 }}</template>
            </el-table-column>
            <el-table-column label="占比" align="center">
              <template slot-scope="{row,$index}">{{ row.total == 0 ? 0 : (row.p3/row.total*100).toFixed(2) }}</template>
            </el-table-column>
            <el-table-column v-if="queryParams.type != 'payreceive'" label="人均体力" align="center">
              <template slot-scope="{row,$index}">{{ row.p3 == 0 ? 0 : (row.bet.p3/row.p3).toFixed(2) }}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="30%-40%" align="center">
            <el-table-column label="玩家数" align="center">
              <template slot-scope="{row,$index}">{{ row.p4 }}</template>
            </el-table-column>
            <el-table-column label="占比" align="center">
              <template slot-scope="{row,$index}">{{ row.total == 0 ? 0 : (row.p4/row.total*100).toFixed(2) }}</template>
            </el-table-column>
            <el-table-column v-if="queryParams.type != 'payreceive'" label="人均体力" align="center">
              <template slot-scope="{row,$index}">{{ row.p4 == 0 ? 0 : (row.bet.p4/row.p4).toFixed(2) }}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="40%-50%" align="center">
            <el-table-column label="玩家数" align="center">
              <template slot-scope="{row,$index}">{{ row.p5 }}</template>
            </el-table-column>
            <el-table-column label="占比" align="center">
              <template slot-scope="{row,$index}">{{ row.total == 0 ? 0 : (row.p5/row.total*100).toFixed(2) }}</template>
            </el-table-column>
            <el-table-column v-if="queryParams.type != 'payreceive'" label="人均体力" align="center">
              <template slot-scope="{row,$index}">{{ row.p5 == 0 ? 0 : (row.bet.p5/row.p5).toFixed(2) }}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="50%-60%" align="center">
            <el-table-column label="玩家数" align="center">
              <template slot-scope="{row,$index}">{{ row.p6 }}</template>
            </el-table-column>
            <el-table-column label="占比" align="center">
              <template slot-scope="{row,$index}">{{ row.total == 0 ? 0 : (row.p6/row.total*100).toFixed(2) }}</template>
            </el-table-column>
            <el-table-column v-if="queryParams.type != 'payreceive'" label="人均体力" align="center">
              <template slot-scope="{row,$index}">{{ row.p6 == 0 ? 0 : (row.bet.p6/row.p6).toFixed(2) }}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="60%-70%" align="center">
            <el-table-column label="玩家数" align="center">
              <template slot-scope="{row,$index}">{{ row.p7 }}</template>
            </el-table-column>
            <el-table-column label="占比" align="center">
              <template slot-scope="{row,$index}">{{ row.total == 0 ? 0 : (row.p7/row.total*100).toFixed(2) }}</template>
            </el-table-column>
            <el-table-column v-if="queryParams.type != 'payreceive'" label="人均体力" align="center">
              <template slot-scope="{row,$index}">{{ row.p7 == 0 ? 0 : (row.bet.p7/row.p7).toFixed(2) }}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="70%-80%" align="center">
            <el-table-column label="玩家数" align="center">
              <template slot-scope="{row,$index}">{{ row.p8 }}</template>
            </el-table-column>
            <el-table-column label="占比" align="center">
              <template slot-scope="{row,$index}">{{ row.total == 0 ? 0 : (row.p8/row.total*100).toFixed(2) }}</template>
            </el-table-column>
            <el-table-column v-if="queryParams.type != 'payreceive'" label="人均体力" align="center">
              <template slot-scope="{row,$index}">{{ row.p8 == 0 ? 0 : (row.bet.p8/row.p8).toFixed(2) }}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="80%-90%" align="center">
            <el-table-column label="玩家数" align="center">
              <template slot-scope="{row,$index}">{{ row.p9 }}</template>
            </el-table-column>
            <el-table-column label="占比" align="center">
              <template slot-scope="{row,$index}">{{ row.total == 0 ? 0 : (row.p9/row.total*100).toFixed(2) }}</template>
            </el-table-column>
            <el-table-column v-if="queryParams.type != 'payreceive'" label="人均体力" align="center">
              <template slot-scope="{row,$index}">{{ row.p9 == 0 ? 0 : (row.bet.p9/row.p9).toFixed(2) }}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="90%-100%" align="center">
            <el-table-column label="玩家数" align="center">
              <template slot-scope="{row,$index}">{{ row.p10 }}</template>
            </el-table-column>
            <el-table-column label="占比" align="center">
              <template slot-scope="{row,$index}">{{ row.total == 0 ? 0 : (row.p10/row.total*100).toFixed(2) }}</template>
            </el-table-column>
            <el-table-column v-if="queryParams.type != 'payreceive'" label="人均体力" align="center">
              <template slot-scope="{row,$index}">{{ row.p10 == 0 ? 0 : (row.bet.p10/row.p10).toFixed(2) }}</template>
            </el-table-column>
          </el-table-column>
        </el-table>

      </el-card>
    </template>

  </BasicLayout>
</template>

<script>

import { actCollectStage } from '@/api/statistics/event/event'
import { getActivtyList } from '@/api/config/activity-cfg'
import { Message } from 'element-ui'

export default {
  name: 'ActStage',
  data() {
    return {
      pickerOptions: {
        disabledDate: time => time.getTime() > Date.now() // 可选择今天以前的日期
      },
      queryParams: {
        name: '',
        id: '',
        type: '',
        count: 0,
        isPay: 0,
        dateList: [],
        isExport: 0
      },
      loading: false,
      dateDisabled: true,
      payEvent: false,
      allUserEvent: 0,
      isPay: 0,
      payType: [{ label: '所有玩家', value: 0 }, { label: '付费玩家', value: 1 }, { label: '免费玩家', value: 2 }],
      userType: [{ label: '所有玩家', value: 0 }, { label: '体力小于5用户', value: 1 }],
      tableLoad: false,
      aid: '',
      tableData: [],
      dateList: []
    }
  },
  created() {
    this.dateList = []
  },
  methods: {
    fetchData(isExport) {
      this.loading = true
      this.queryParams.count = 0
      this.queryParams.isPay = 0
      if (this.allUserEvent) {
        this.queryParams.count = 1
      }
      if (this.isPay) {
        this.queryParams.isPay = 1
      }
      this.queryParams.isExport = 0
      if (isExport) {
        this.queryParams.isExport = 1
      }

      actCollectStage(this.queryParams).then(response => {
        this.loading = false
        if (this.queryParams.isExport) {
          window.open(process.env.VUE_APP_BASE_API + '/' + response.data.path)
          this.msgSuccess('导出成功')
          return
        }
        let maxStage = 0
        if (response.data.toSql) {
          this.dateDisabled = true
        }
        for (const stage in response.data.list) {
          const stageInt = parseInt(stage)
          if (stageInt > maxStage) {
            maxStage = stageInt
          }
        }
        if (maxStage === 0) {
          this.msgError('无数据')
          return
        }
        const data = []
        for (let i = 1; i <= maxStage; i++) {
          const row = response.data.list[i]
          if (row == null) {
            data.push(
              {
                stage: i,
                total: 0,
                totalBet: 0,
                p1: 0,
                p2: 0,
                p3: 0,
                p4: 0,
                p5: 0,
                p6: 0,
                p7: 0,
                p8: 0,
                p9: 0,
                p10: 0,
                bet: {
                  p1: 0,
                  p2: 0,
                  p3: 0,
                  p4: 0,
                  p5: 0,
                  p6: 0,
                  p7: 0,
                  p8: 0,
                  p9: 0,
                  p10: 0
                }
              })
          } else {
            data.push(
              {
                stage: i,
                total: row.total,
                totalBet: row.totalBet,
                p1: row.section[1],
                p2: row.section[2],
                p3: row.section[3],
                p4: row.section[4],
                p5: row.section[5],
                p6: row.section[6],
                p7: row.section[7],
                p8: row.section[8],
                p9: row.section[9],
                p10: row.section[10],
                bet: {
                  p1: row.bet[1],
                  p2: row.bet[2],
                  p3: row.bet[3],
                  p4: row.bet[4],
                  p5: row.bet[5],
                  p6: row.bet[6],
                  p7: row.bet[7],
                  p8: row.bet[8],
                  p9: row.bet[9],
                  p10: row.bet[10]
                }
              })
          }
        }
        this.tableData = data
        this.tableLoad = false
      })
    },
    handleQuery(isExport = false) {
      if (this.dateList.length <= 0) {
        this.msgError('请选择时间')
        return
      }
      const start_time = new Date(this.dateList[0])
      const endTime = new Date(this.dateList[1])
      this.tableLoad = true
      this.queryParams.dateList = [start_time.getTime() / 1000 - 8 * 3600, endTime.getTime() / 1000 - 8 * 3600]
      this.queryParams.name = this.payEvent ? 'payreceive' : 'spinresult'
      this.fetchData(isExport)
    },
    handleChange() {
      this.dateDisabled = true
    },
    querySearchAsync(queryString, cb) {
      if (!queryString) {
        cb([])
        return
      }
      getActivtyList({ id: parseInt(queryString) }).then(res => {
        const results = []
        for (let i = 0; i < res.data.list.length; i++) {
          results.push(res.data.list[i])
        }
        cb(results)
      })
    },
    handleSelect(item) {
      if (item.type != 'super_collect' && item.type != 'rank') {
        Message({ message: '不支持该类型', type: 'error', duration: 5 * 1000 })
      } else {
        const start_time = new Date(item.start_time)
        const endTime = new Date(item.end_time)
        this.dateDisabled = false
        this.queryParams.id = item.id + ''
        this.queryParams.type = item.type
        this.dateList = [item.start_time, item.end_time]
        this.pickerOptions.disabledDate = time => !(start_time.getTime() - 3600 * 1000 <= time.getTime() && time.getTime() <= endTime.getTime())
      }
    }
  }
}
</script>

<style scoped>
</style>
